var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.to)?_c('router-link',{staticClass:"more",attrs:{"to":_vm.to}},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_c('a',{staticClass:"more",attrs:{"href":_vm.href}},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }